import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AccountPart from "./AccountPart";
import { ChevronRightIcon, CrownIcon, GroupIcon } from '../../../constants/Icons';

const Profile = () => {
  const [isLink, setLink] = useState("account");

  const renderContent = () => {
    switch (isLink) {
      case "account":
        return <AccountPart />;
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="row">

            <div className="col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between flex-column mb-md-0">

                    <ul className="list-group list-group-flush radius-10">
                      <Link onClick={() => setLink("account")}
                        className={`list-group-item p-1 d-flex align-items-center radius-10 mb-2 border 
                          ${isLink === "account" ? "active" : ""}`}>
                        <GroupIcon iClass={"mx-2 fs-18"}/>
                        <span className="align-center fs-14">Account</span>
                        <div className="ms-auto me-1">
                          <div className="mb-0">
                            <ChevronRightIcon/>
                          </div>
                        </div>
                      </Link>


                      <Link className="list-group-item p-1 d-flex align-items-center radius-10 mb-0 border">
                        <CrownIcon iClass={"mx-2 fs-18"}/>
                        <span className="align-center fs-14">Billing & Plans</span>
                        <div className="ms-auto me-1">
                          <div className="mb-0">
                            <ChevronRightIcon/>
                          </div>
                        </div>
                      </Link>

                    </ul>
                  </div>
                </div>
              </div>
            </div>



            <div className="col-lg-9">
              {renderContent()}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
